import React from "react";
import "../../styles/homepage.css";
import {NavLink} from 'react-router-dom'

function Header() {
  return (
      <div className="roots">
       <header id="home" className="m-4">
        <div className="left">
          <h2>
            <span>in</span>Force
          </h2>
        </div>
        <div className="right">
          <NavLink className="links active p-2" to="/">
            Home
          </NavLink>
          <NavLink className="links p-2" type="button" to="/laws">
            Traffic Violations
          </NavLink>

          <NavLink
            className="links p-2"
            type="button"
            to="/policestation"
          >
            Police Stations
          </NavLink>

        </div>
      </header>
      </div>
  );
}

export default Header;
